// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1icFO","amount":"Amount_amount__273G8","tip":"Amount_tip__2QTdd","tipHeader":"Amount_tipHeader__23M0o","tipsWrap":"Amount_tipsWrap__3W6mq"};